<template>
  <img src="~/assets/icon/icon-map-point.svg" />
</template>
